module.exports = __webpack_public_path__ + "img/bestprice.85d27502.svg";